import React from 'react';
import BlockContainer from './BlockContainer';
import styles from './PageFour.module.scss';
import SwiperContainer from './SwiperContainer';
import TitleContainer from './TitleContainer';

export default function PageFour() {

    return (
        <div className={styles["container"]} id="pageFour">
            <BlockContainer />
            <div className={styles["main-container"]}>
                <TitleContainer file={"./assets/page_4/4_title.png"} />
                <div className={styles["swiper-container"]}>
                    <SwiperContainer />
                </div>
            </div>
        </div>
    )
}